const state = {
    // 当前语言
    lang: 'en',
    waiting: false, // 等待层
    // 底部功能栏状态
    toolbarType: 'unauth',
    // 兑换码
    code: '',
    // 转盘实例
    lottery: null,
    popup: {
        // 通用文本弹窗
        comm: false,
        // 分享弹层
        share: false,
        // 活动规则
        rule: false,
        // 战力页规则
        powerInfo: false,
        // 礼品卡
        giftCard: false,
        // 实物奖励
        entity: false,
        // 礼包兑换码
        code: false,
        // 保存名字
        saveName: false,
        // 转盘
        lottery: false,
        // 好友列表弹窗
        friend: false,
        // 登录提示
        loginTips: false,
        // 分享提示
        shareTips: false,
        // 中奖记录
        rewardRecord: false
    },
    //  通用文本弹窗文案
    commText: {
        text: '',
        hasCls: true,
        size: 'big',
        hasDownload: false
    },
    token: null,
    // 活动id
    activeId: null,
    // 300积分活动id
    activeId300: null,
    // 600积分活动id
    activeId600: null,
    // 首次对战活动id
    activeIdFirst: null,
    // 用户信息
    userinfo: null,
    // 抽中奖品
    drawReward: null,
    // 转盘关闭按钮
    lotteryClsShow: true,
    // game
    gameAni: null, // 游戏实例
    game: {
        user_name: '', // 用户昵称
        view: 'start', // start => 登录前， home =>主页，pk=>对战页，share=>分享页
        canPk: false, // 是否开始pk
        tags: [], // 标签
        star: [], // 星座
        dragonList: [], // 接口龙列表
        pkwordsList: [] // 接口对战文案列表
    },
    createingSharePic: false, // 是否正在生成图片
    // 分享图片链接（截图）
    gamePic: '',
    // 分享图片链接（默认）
    defaultPic: '',
    // 抽中的兑换码
    codeReward: null,
    bgmPlayState: false, // false暂停，true播放
    bgmVolume: 0.5, // 背景音音量
    // 300积分中奖记录
    reward300Record: null,
    // 600积分中奖记录
    reward600Record: null
};
export default state;
